import type {
  ChatMessage,
  NavItem,
  AgentData,
  PolicyData,
  PolicyRow,
  QuickAction,
  User,
} from '../features/chat/chat.types';

/* ============================================
   Navigation Data
   ============================================ */

export const NAV_ITEMS: NavItem[] = [
  { id: 'channels', label: 'Workspaces', icon: 'channels' },
  { id: 'Reportingamp', label: 'Reporting AMP', icon: 'campaigns', badge: 16 },
  {
    id: 'renewals',
    label: 'Renewals',
    icon: 'renewals',
    isActive: true,
    children: [
      { id: 'annuals', label: 'Annuals', count: 8 },
      { id: 'last-month', label: 'Last Month', count: 2 },
    ],
  },
  { id: 'lead-nurture', label: 'Leads', icon: 'lead' },
  { id: 'marketing', label: 'Marketing', icon: 'marketing' },
  { id: 'agency-perf', label: 'Agency Performance', icon: 'performance' },
];

export const NAV_BOTTOM_ITEMS: NavItem[] = [
  { id: 'add-new', label: 'Add New', icon: 'add' },
  // { id: 'direct-messages', label: 'Direct Messages', icon: 'messages' },
  { id: 'marketplace', label: 'Marketplace', icon: 'marketplace' },
];

/* ============================================
   Chat Messages
   ============================================ */

export const MOCK_MESSAGES: ChatMessage[] = [
  {
    id: 'sys-1',
    role: 'system',
    content:
      'Policy #4432.2X (Johnson Family) is expiring in 14 days. Premium increase: +22%',
    timestamp: '5:48 PM',
    metadata: { linkedEntity: 'Johnson Family' },
  },
  {
    id: 'user-1',
    role: 'user',
    content: 'Give me the Overview and Options of new Plans for the Johnson Family',
    timestamp: '5:49 PM',
  },
  {
    id: 'ai-1',
    role: 'assistant',
    content:
      "Sure! Here's your overview. The carrier rates went up across the board in their zip code. A comparison option with Progressive and Travelers with the same coverage limits.\n\nHere are the best options for the Johnson Family",
    timestamp: '5:49 PM',
    metadata: {
      // model: 'Sonnet 4.5',
      table: {
        headers: ['Plan Name', 'Price', 'Savings'],
        rows: [
          ['Progressive', '$1,240/yr', '$350'],
          ['Travelers', '$1,110/yr', '$280'],
          ['Current Carrier', '$1,590/yr', '—'],
        ],
      },
    },
  },
];

/* ============================================
   Quick Actions
   ============================================ */

export const QUICK_ACTIONS: QuickAction[] = [
  // { id: 'leads', label: 'Show New Leads', icon: 'leads', color: '#f97316' },
  // { id: 'quotes', label: 'Get Quotes', icon: 'quotes', color: '#a855f7' },
  // { id: 'workflow', label: 'Create Workflow', icon: 'workflow', color: '#22c55e' },
];

/* ============================================
   Dashboard Data
   ============================================ */

export const AGENTS_DATA: AgentData[] = [
  { name: 'Alice', clients: 85, color: '#8b5cf6' },
  { name: 'Bob', clients: 62, color: '#6366f1' },
  { name: 'Carol', clients: 94, color: '#a78bfa' },
  { name: 'David', clients: 48, color: '#c4b5fd' },
  { name: 'Eve', clients: 73, color: '#818cf8' },
  { name: 'Frank', clients: 55, color: '#7c3aed' },
];

export const POLICY_BREAKDOWN: PolicyData[] = [
  { label: 'Homeowners', value: 42, color: '#22d3ee' },
  { label: 'Auto', value: 30, color: '#8b5cf6' },
  { label: 'GL', value: 20, color: '#34d399' },
  { label: 'WC', value: 8, color: '#fbbf24' },
];

export const POLICY_TABLE_ROWS: PolicyRow[] = [
  { propertyName: 'Johnson Family', value: '$2,400', header1: '1234 Oak Lane', header2: '$1,240' },
  { propertyName: 'Smith Corp', value: '$8,200', header1: '456 Main St', header2: '$4,100' },
  { propertyName: 'Garcia LLC', value: '$3,600', header1: '789 Elm Ave', header2: '$1,800' },
  { propertyName: 'Chen Industries', value: '$12,500', header1: '101 Pine Rd', header2: '$6,250' },
];

/* ============================================
   Mock User
   ============================================ */

export const MOCK_USER: User = {
  id: 'user-001',
  name: 'momentumhub',
  email: 'momentumhub@momentumhub.com',
  role: 'admin',
  isAMSUser: false,
};
